<template>
  <main
    class="main-content flex-grow-1 p-4 overflow-auto mt-6"
    style="background-color: #f8f9fa"
  >
    <div class="d-flex align-items-center mx-4">
      <button
        class="back-btn btn-link me-2"
        @click="$router.push('/transaction')"
      >
        <i
          class="fa fa-chevron-left"
          style="width: 24px; height: 24px"
          aria-hidden="true"
        ></i>
      </button>
      <h2 class="text-header-page mt-3">Detail Batch</h2>
      <div class="ms-auto d-flex align-items-center gap-2">
        <div
          class="bg-light border rounded-pill px-4 gap-4 d-flex align-items-center"
          style="height: 40px"
        >
          <small class="text-muted me-1">Batch ID</small>
          <strong class="text-dark">{{ batchId }}</strong>
        </div>
        <button
          class="btn btn-sm btn-primary-gradient"
          style="margin-top: 15px; height: 40px"
          @click="downloadSummary()"
        >
          Download Summary
        </button>
      </div>
    </div>
    <div class="card border-0 shadow-sm mx-4">
      <div class="card-body p-0">
        <BatchSummaryComponent
          :dateTime="dateTime"
          :totalAmount="totalAmount"
          :adminFee="adminFee"
          :overallStatus="overallStatus"
          :successRate="successRate"
          :totalEntries="totalEntries"
          :successCount="successCount"
          :failedCount="failedCount"
        />
      </div>
    </div>
    <!-- Section 1: Batch Summary Component -->

    <div class="transation-section">
      <!-- Section 2: Transaction List Component -->
      <TransactionListComponent :transactions="transactions" />
    </div>
    <Loading :isLoading="isLoading" />
  </main>
</template>

<script>
import { detailBatch } from "../../api/transaction";
import BatchSummaryComponent from "./BatchSummaryComponent.vue";
import TransactionListComponent from "./TransactionListComponent.vue";
import { generateBatchTransactionReport } from "./functionPDF";
import Loading from "@/components/Loading";

export default {
  name: "TransactionDetail",
  components: {
    BatchSummaryComponent,
    TransactionListComponent,
    Loading,
  },
  data() {
    return {
      uuid: "",
      batchId: "",
      dateTime: "",
      totalAmount: "",
      adminFee: "",
      overallStatus: "",
      merchantName: "",
      successRate: 0,
      totalEntries: 0,
      successCount: 0,
      failedCount: 0,
      transactions: [],
      isLoading: false,
    };
  },
  computed: {},
  mounted() {
    this.fetchBatchDetails();
  },
  methods: {
    async fetchBatchDetails() {
      const uuidFromTrx = this.$route.params.id;
      if (uuidFromTrx) {
        this.uuid = uuidFromTrx;
      }
      const response = await detailBatch(this.uuid);
      if (response.status === "success" && response.data.batch) {
        const batch = response.data.batch;
        const statistic = response.data.statistics;
        this.transactions = batch.transactions || [];
        this.batchId = batch.batch_id || "";
        this.dateTime = batch.batch_datetime || "";
        this.status = batch.status || "";
        this.totalAmount = batch.grand_total_amount || "";
        this.adminFee = batch.total_admin_fee || "";
        this.overallStatus = batch.status || "";
        this.totalEntries = batch.total_recipient || 0;
        (this.failedCount = statistic.failed_count),
          (this.successCount = statistic.success_count),
          (this.successRate = statistic.success_rate || 0);
      } else {
        this.transactions = [];
      }
    },
    async downloadSummary() {
      const uuidFromTrx = this.$route.params.id;
      if (uuidFromTrx) {
        this.uuid = uuidFromTrx;
      }
      this.isLoading = true;
      const response = await detailBatch(this.uuid);
      if (response.status === "success" && response.data.batch) {
        generateBatchTransactionReport(response);
        this.isLoading = false;
      } else {
        this.$swal("Failed to fetch batch details for summary download.");
      }
    },
  },
};
</script>

<style scoped>
.back-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: black;
}

.arrow {
  font-size: 1.5em;
  color: black;
}

h2 {
  margin-bottom: 1rem;
  display: inline-block;
}
</style>
